import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { entityKeys } from "../queryKeys";
import { getSports } from "../services/sports.service";

export const useGoalngoSports = () => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [entityKeys.sports, i18n.language],
    queryFn: getSports,
  });
};
